import React from 'react';
import Routes from './router';

const Main: React.FC<{}> = () => {
  return(
    <div>
      <Routes />
    </div>
  );
};

export default Main;
